import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import InstantLoans from './pages/InstantLoans/InstantLoans';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TncAndPrivacyPolicy from './pages/TncAndPrivacyPolicy/TncAndPrivacyPolicy';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/instant-loans" element={<InstantLoans />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/legal" element={<TncAndPrivacyPolicy />} />
            <Route path="*" element={<Navigate to="/instant-loans" replace />} />
        </Routes>
    );
};

export default AppRoutes;
